<template>
    <div id="about_sidebar" >

      <ul class="nav nav-pills nav-stacked text-center" style="background: #fff">


        <li class="active" @click="getnum(1)"><a href="javascript:;">品牌故事</a></li>
<!--        <li class="active" @click="getnum(1)"><router-link to="/brand">品牌故事</router-link></li>-->

        <li  @click="getnum(2)"><a href="javascript:;">加入我们</a></li>
<!--        <li @click="getnum(2)"><router-link to="/join" >加入我们</router-link></li>-->

<!--        <li @click="getnum(3)"><router-link to="/touzi" >投资我们</router-link></li>-->
        <li  @click="getnum(3)"><a href="javascript:;">投资我们</a></li>
        <li  @click="getnum(4)"><a href="javascript:;">联系我们</a></li>
<!--        <li @click="getnum(4)"><router-link to="/contact" >联系我们</router-link></li>-->
      </ul>

    </div>
</template>

<script>
  import {mapState} from 'vuex'
    export default {
        name: "about_sidebar",

      computed: {
        // ...mapState(["sidebar_status"]),
      },
      data(){
          return{
            about_sidebar:1
          }
      },
      methods:{
          getnum(data){
           this.$store.commit('getnum',data)
            if(data==1){
              this.$router.push('/PinPai')
            }else if (data==2){
              this.$router.push('/join')

            }else if(data==3){
              this.$router.push('/touzi')

            }else if(data==4){
              this.$router.push('/contact')
            }

          }
      }
    }
</script>

<style scoped>
  .nav-pills>li>a{
  color: #333;
}
  .nav-pills>li.active>a, .nav-pills>li.active>a:focus, .nav-pills>li.active>a:hover {
    color: #fff;
    background: #167C8A;

  }
</style>



// WEBPACK FOOTER //
// src/components/about_sidebar.vue